import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Body } from '@vds/typography';
import { Accordion, AccordionItem, AccordionHeader, AccordionTitle } from '@vds/accordions';
import { dataTrack } from '../../utils/vzdl';
import { openViewVzTag } from '../../utils/unifiedVzTag';
import { clearDetails, updateParserAttempt, updateParserAddressID, updateParserShowAll, updateHideMiniLq } from '../loop-qual-app/actions';
import { updateSuggestedAddr, onStreetSelection } from '../address-lookup/actions';
import { getSHA256Val } from '../../utils/lq-response-tranformer';
import { updateHelpView } from './actions';
import Button from '../common/Button';
import VdsRadioButton from '../common/RadioButton';
import UnitLookup from '../units-lookup';
import { showLoader, hideLoader } from '../common/loader/actions';
import { restUnitDetails, loadUnits } from '../units-lookup/actions';
import { pageJson } from './constants';
import { getCurrentDocument } from '../../utils/helperUtil';

const AddressSection = styled.ul`
  margin-left: 0;
  list-style: none;
  padding-top: small;
  margin-bottom: auto;
  padding: 0;
`;
const Space = styled.div`
  height: 20px;
  display: inline-block;
`;

class AddressSuggestion extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showAll: false,
      clickedAddressRadio: false,
      clickedSubmitRadio: false,
    };
    this.getDocument = getCurrentDocument();
  }

  onChangeShowAllClicked = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showAll: !prevState.showAll }));
    this.props.dispatch(updateParserShowAll(!this.state.showAll));
  };

  onAddressReEnter = (e) => {
    e.preventDefault();
    const parserAttempted = this.props.parserAttempt;
    clearDetails(this.props.dispatch, '', this.props.fiosDetails, this.props.loopQualApp);
    this.props.dispatch(updateParserAttempt(parserAttempted));
    openViewVzTag('lq check avail - reenter');
    this.props.dispatch(updateHideMiniLq(false));
    setTimeout(() => {
      const streetInput = this.getDocument.querySelector('#streetaddress');
      if (streetInput) {
        streetInput.focus();
      }
    }, 1000);
  };

  onAddressNotFound = () => {
    openViewVzTag('lq help');
    updateHelpView(this.props.dispatch, true);
  };

  onDefaultOptionSelect = (e) => {
    e.preventDefault();
    this.props.dispatch(onStreetSelection(null));
    this.props.dispatch(updateParserAddressID(e.target.id));
    this.setState({ clickedAddressRadio: false, clickedSubmitRadio: true });
  };

  onAddressSelect = (e) => {
    e.preventDefault();
    let idx = parseInt(e.target.id);
    try {
      if (
        this.props.lqResult.suggestedAddress[idx] &&
        this.props.lqResult.suggestedAddress[idx].addressString &&
        this.props.lqResult.suggestedAddress[idx].addressString === e.target.value
      ) {
        console.log('Address matched');
      } else {
        idx = 0;
      }
    } catch (ex) {
      console.log(`Exception in onAddressSelect${ex}`);
      idx = 0;
    }
    const selectedAddress = idx ? this.props.lqResult.suggestedAddress[idx] : this.props.lqResult.suggestedAddress[0];
    const selectedState = this.props.customerStreetDetails;
    const selectedStreet = selectedAddress ? selectedAddress.addressString.split(',') : '';
    const entireStreetAddress = selectedAddress ? selectedAddress.addressString : '';
    const addressId = selectedAddress && selectedAddress.addressID ? selectedAddress.addressID.split('.')[0] : '';
    let parserAddressLine2 = '';
    try {
      parserAddressLine2 = selectedAddress && selectedAddress.addressString ? selectedAddress.addressString.replace(', USA', '') : '';
      parserAddressLine2 = parserAddressLine2.split(',');
      if (parserAddressLine2 && parserAddressLine2.length === 5) {
        parserAddressLine2 = parserAddressLine2[1].trim();
      } else {
        parserAddressLine2 = '';
      }
    } catch (ex) {
      console.log(`Exception in parserAddressLine2${ex}`);
      parserAddressLine2 = '';
    }
    const selectedAdr = {
      ntasAddrID: addressId && addressId.length <= 10 ? addressId : '',
      locusID: addressId && addressId.length === 12 ? addressId : '',
      city: (selectedAddress && selectedAddress.city) || (selectedState && (selectedState.altCity || selectedState.muni)) || '',
      street: selectedStreet && selectedStreet[0].trim(),
      state: (selectedStreet && selectedAddress.state) || (selectedState && selectedState.state) || '',
      zip: (selectedAddress && selectedAddress.zipCode) || (selectedState && selectedState.zip) || '',
      multipleAddress: 'Y',
      entireStreetAddress: entireStreetAddress || '',
      parserAddressLine2,
    };
    updateSuggestedAddr(selectedAdr, this.props.dispatch);
    this.setState({ clickedAddressRadio: true, clickedSubmitRadio: false });
    if (addressId) {
      getSHA256Val(addressId);
    }
    this.props.dispatch(updateParserAddressID(e.target.id));
    setTimeout(() => {
      this.fetchUnits();
    }, 500);
  };

  fetchUnits() {
    this.props.dispatch(restUnitDetails());
    if (this.props?.customerStreetDetails?.addressClassification !== 'SFU' && this.props?.customerStreetDetails?.addressClassification !== 'SBU') {
      this.props.dispatch(showLoader());
      loadUnits(this.props.customerStreetDetails, this.props.dispatch, this.props.loopQualApp)
        .then(() => {
          this.props.dispatch(hideLoader());
        })
        .catch(() => {
          this.props.dispatch(hideLoader());
        });
    }
  }

  render() {
    const radioButtonAddressArray = this.props.lqResult.suggestedAddress
      .filter((elem, idx) => this.props.parserShowAll || idx < 5)
      .map((elem, idx) => ({
        name: 'sugg-group',
        id: idx,
        inputId: `input-${idx}`,
        children: <Body>{elem.addressString || ''}</Body>,
        value: elem.addressString || '',
        ariaLabel: elem.addressString || '',
      }));
    const radioButtonDefaultSubmitArray = [
      {
        name: 'sugg-Degroup',
        id: 'ReEnterAddress',
        inputId: 'input-ReEnterAddress',
        children: <Body>{pageJson.ReEnterAddress}</Body>,
        value: 'Y',
      },
      {
        name: 'sugg-Degroup',
        id: 'CallVerizonNos',
        inputId: 'input-CallVerizonNos',
        children: <Body>{pageJson.noAddressFound}</Body>,
        value: 'N',
      },
    ];
    const radioSubmitChecked = !!(this.props.parserAddressID === 'ReEnterAddress' || this.props.parserAddressID === 'CallVerizonNos');
    const radioAddressChecked = !!(
      this.props.parserAddressID !== 'ReEnterAddress' &&
      this.props.parserAddressID !== 'CallVerizonNos' &&
      this.props.parserAddressID !== 0
    );
    const radioAddressDefaultValue = radioAddressChecked
      ? this.props.customerStreetDetails && this.props.customerStreetDetails.entireStreetAddress
      : '';
    const radioSubmitDefaultValue = radioSubmitChecked
      ? this.props.parserAddressID === 'ReEnterAddress'
        ? 'Y'
        : this.props.parserAddressID === 'CallVerizonNos'
        ? 'N'
        : ''
      : '';
    return (
      <>
        <React.Fragment>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>{pageJson.doYouSeeYourAddress}</p>
          <AddressSection className="vdsRadioConflictWithVZRF">
            <VdsRadioButton
              parserView
              value={this.state.clickedSubmitRadio ? '-1' : radioAddressDefaultValue}
              selected={!!(radioAddressChecked && this.state.clickedAddressRadio)}
              defaultValue="-1"
              onChange={(e) => {
                this.onAddressSelect(e);
              }}
              data={radioButtonAddressArray}
              data-track={dataTrack('link', 'multipleAddress - street address select')}
            />
            {radioButtonAddressArray && radioButtonAddressArray.length > 4 && (
              <Accordion id="accordionHelpSection">
                <AccordionItem>
                  <AccordionHeader
                    onClick={this.onChangeShowAllClicked}
                    onKeyPress={this.onChangeShowAllClicked}
                    data-track={dataTrack('link', this.state.showAll ? 'multipleAddress - see less choices' : 'multipleAddress - see more choices')}
                  >
                    <AccordionTitle>{this.props.parserShowAll ? 'See less choices' : 'See more choices'}</AccordionTitle>
                  </AccordionHeader>
                </AccordionItem>
              </Accordion>
            )}
            <Space />
            <VdsRadioButton
              parserView
              value={this.state.clickedAddressRadio ? '-1' : radioSubmitDefaultValue}
              selected={!!(radioSubmitChecked && this.state.clickedSubmitRadio)}
              defaultValue="-1"
              onChange={(e) => {
                this.onDefaultOptionSelect(e);
              }}
              data={radioButtonDefaultSubmitArray}
              data-track={dataTrack(
                'link',
                this.props.parserAddressID === 'ReEnterAddress' ? 'multipleAddress - reenter my address' : 'multipleAddress - cant find my address',
              )}
            />
          </AddressSection>

          <div style={{ marginTop: '20px' }}>
            {(this.props.parserAddressID === 'ReEnterAddress' || this.props.parserAddressID === 'CallVerizonNos') && (
              <Button
                size="large"
                inverted={false}
                disabled={false}
                secondary={false}
                onClick={this.props.parserAddressID === 'ReEnterAddress' ? this.onAddressReEnter : this.onAddressNotFound}
                data-track={dataTrack('link', 'multipleAddress - submit')}
              >
                Submit
              </Button>
            )}
          </div>
        </React.Fragment>
        {radioAddressChecked && <UnitLookup />}
      </>
    );
  }
}
export default AddressSuggestion;
AddressSuggestion.propTypes = {
  lqResult: PropTypes.string,
  dispatch: PropTypes.string,
  customerStreetDetails: PropTypes.string,
  parserAttempt: PropTypes.number,
  parserAddressID: PropTypes.string,
  fiosDetails: PropTypes.string,
  loopQualApp: PropTypes.string,
  parserShowAll: PropTypes.bool,
};
